import { USER_CREATE_GQL, USER_DELETE_GQL, USER_UPDATE_GQL } from './gql';
import { apolloClient } from '../client';
import { MutationSignupArgs, UpdateUserMutation, UpdateUserMutationVariables, User } from '../types.generated';
import { UserInput } from './user.types';

export const createUserMutation = async (payload: MutationSignupArgs): Promise<User | undefined> => {
  const response = await apolloClient.mutate<{ createUser: User }>({
    mutation: USER_CREATE_GQL,
    variables: {
      email: payload.email,
      password: payload.password,
      name: payload.name,
      locale: payload.locale,
      isAdmin: payload.isAdmin,
    },
  });

  return response.data?.createUser;
};

export const updateUserMutation = async (payload: UserInput) => {
  const { id, ...restData } = payload;
  const response = await apolloClient.mutate<UpdateUserMutation, UpdateUserMutationVariables>({
    mutation: USER_UPDATE_GQL,
    variables: {
      id,
      input: restData,
    },
  });

  return response.data?.updateUser;
};

export const deleteUserMutation = async (id: string): Promise<string | undefined> => {
  const response = await apolloClient.mutate<{ deleteUser: User['id'] }>({
    mutation: USER_DELETE_GQL,
    variables: {
      id: id,
    },
  });

  return response.data?.deleteUser;
};
